import React, { useEffect, useState } from "react";

// Replace with your deployed Google Apps Script URL
const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbyzA_WqDW_MHtYpvXnEBhoMSrdqKo1aI2Q5KNr5L8h-FRdCRPQnoao6tVD4V4VnyjiR/exec";

function Notifications() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${SCRIPT_URL}?type=contacts`)
      .then((res) => res.json())
      .then((data) => {
        setContacts(data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching contacts:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Notifications</h2>

      {loading ? (
        <p>Loading...</p>
      ) : contacts.length === 0 ? (
        <p>No notifications found.</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f2f2f2" }}>
                <th style={thStyle}>Full Name</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>Number</th>
                <th style={thStyle}>Message</th>
                <th style={thStyle}>Date</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((contact, index) => (
                <tr key={index} style={{ textAlign: "center" }}>
                  <td style={tdStyle}>{contact.FullName}</td>
                  <td style={tdStyle}>{contact.Email}</td>
                  <td style={tdStyle}>{contact.Number}</td>
                  <td style={tdStyle}>{contact.Message}</td>
                  <td style={tdStyle}>{contact.Date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// Table cell styles
const thStyle = {
  padding: "10px",
  border: "1px solid #ddd",
};

const tdStyle = {
  padding: "10px",
  border: "1px solid #ddd",
};

export default Notifications;